import React from 'react';
import PropTypes from 'prop-types';
import { Mixin } from 'hops-mixin';
import * as Sentry from '@sentry/browser';
import { captureException } from './browser';

class ErrorBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  componentDidCatch(error, errorInfo) {
    captureException(error, errorInfo);
  }

  render() {
    return this.props.children;
  }
}

class HopsSentryBrowserMixin extends Mixin {
  bootstrap() {
    const options = this.config.sentry || {};

    Sentry.init(options);
  }

  enhanceElement(element) {
    return React.createElement(ErrorBoundary, {}, element);
  }
}

export default HopsSentryBrowserMixin;
export { ErrorBoundary };
